export const GATSBY_GOOGLE_ANALYTICS_COOKIE_NAME =
  'gatsby-plugin-google-analytics-gdpr-cookies'
export const GATSBY_GOOGLE_TAG_MANAGER_COOKIE_NAME =
  'gatsby-plugin-google-tagmanager-gdpr-cookies'
